import AboutUsLayout from '../layouts/AboutUsLayout'

export default function AboutUs() {
  return (
    <AboutUsLayout/>
  );
}